<modal-panel data-testid="trams-invoice-modal-panel" (close)="closeDialog()" >
    <ng-container data-testid="trams-invoice-modal-container">
        <app-invoice-info [invoiceInfo]="data"></app-invoice-info>
        <app-payment-tab-detail [data]="data"></app-payment-tab-detail>
    </ng-container>
  
    <ng-container data-testid="trams-invoice-modal-footer" modalPanelFooter >
      <button data-testid="trams-invoice-modal-close-button" mat-raised-button color="primary" 
        (click)="closeDialog()">Close</button>
    </ng-container>
  </modal-panel>
  